import { CellType, ICell } from "js/crossword/types";
import style from "../css/BoardCell.module.css";

export default function getCellClasses(
  cell: ICell,
  {
    currentClueCell = false,
    activeCell = false,
    print = false,
  }
) {
  const classes = {
    // basic
    [style.container]: true,
    [style.containerRight]: true,
    [style.containerBottom]: true,
    
    // print
    [style.printContainer]: print,

    // highlight
    [style.cellHighlight]: activeCell,
    [style.clueHighlight]: currentClueCell,

    // type
    [style.empty]: cell.type === CellType.Empty,
    [style.clue]: cell.type === CellType.Clue,
  };

  const identifierCell = cell.type === CellType.Identifier;
  
  if (cell.x === 0) {
    classes[style.containerLeft] = !identifierCell;
    classes[style.containerBottom] = !identifierCell;
    
    classes[style.printContainerLeft] = print;
  }
  if (cell.y === 0) {
    classes[style.containerTop] = !identifierCell;
    classes[style.containerRight] = !identifierCell;

    classes[style.printContainerTop] = print;
  }

  return Object.entries(classes)
    .filter(([_, value]) => value)
    .map(([key]) => key);
}
